import { render, staticRenderFns } from "./GlobalNavi.vue?vue&type=template&id=717af721&scoped=true&"
import script from "./GlobalNavi.vue?vue&type=script&lang=ts&"
export * from "./GlobalNavi.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalNavi.vue?vue&type=style&index=0&id=717af721&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717af721",
  null
  
)

export default component.exports